const whatsappUrl = "https://wa.me/qr/B5BVPSPSXGEBM1";

const diferenciais = [
  {
    num: "01",
    icon: "ri-user-heart-line",
    title: "Atendimento Personalizado",
    desc: "Cada projeto é único. Nossa equipe analisa seu espaço e indica a melhor solução em piso vinílico para o seu ambiente, estilo e orçamento.",
    img: "https://readdy.ai/api/search-image?query=friendly%20professional%20flooring%20consultant%20showing%20samples%20to%20a%20happy%20couple%20in%20a%20modern%20showroom%2C%20warm%20lighting%2C%20professional%20service%2C%20ultra%20realistic%20photography&width=700&height=500&seq=dif001&orientation=landscape",
    checks: ["Consultoria gratuita", "Projeto personalizado", "Suporte pós-venda"],
  },
  {
    num: "02",
    icon: "ri-price-tag-3-line",
    title: "Preço Direto da Fábrica",
    desc: "Sem intermediários, sem margem de revenda. Você compra diretamente de quem fabrica, garantindo o melhor preço do mercado com qualidade premium.",
    img: "https://readdy.ai/api/search-image?query=premium%20vinyl%20flooring%20samples%20collection%20displayed%20elegantly%2C%20various%20wood%20tones%20and%20textures%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20ultra%20realistic&width=700&height=500&seq=dif002&orientation=landscape",
    checks: ["Melhor preço garantido", "Qualidade certificada", "Sem taxas ocultas"],
  },
  {
    num: "03",
    icon: "ri-hammer-line",
    title: "Instalação Sem Quebra-Quebra",
    desc: "Nossa tecnologia de encaixe permite instalação rápida, limpa e sem barulho. Ideal para apartamentos onde obras convencionais são proibidas.",
    img: "https://readdy.ai/api/search-image?query=clean%20professional%20vinyl%20flooring%20installation%20in%20progress%20in%20modern%20apartment%2C%20click-lock%20system%2C%20no%20dust%20no%20mess%2C%20professional%20installer%2C%20ultra%20realistic%20photography&width=700&height=500&seq=dif003&orientation=landscape",
    checks: ["Sem poeira nem barulho", "Instalação em 1 dia", "Ideal para condomínios"],
  },
  {
    num: "04",
    icon: "ri-team-line",
    title: "Equipe Especializada",
    desc: "Profissionais treinados e certificados que garantem uma instalação perfeita, com acabamento impecável e atenção a cada detalhe do seu projeto.",
    img: "https://readdy.ai/api/search-image?query=professional%20flooring%20installation%20team%20in%20uniform%20completing%20a%20beautiful%20vinyl%20floor%20installation%20in%20luxury%20apartment%2C%20team%20work%2C%20ultra%20realistic%20photography&width=700&height=500&seq=dif004&orientation=landscape",
    checks: ["Profissionais certificados", "Pontualidade garantida", "Limpeza pós-instalação"],
  },
];

export default function Diferenciais() {
  return (
    <section id="diferenciais" className="py-14 md:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-20">
          <span className="inline-block text-amber-700 text-xs font-bold tracking-widest uppercase mb-3">Nossos Diferenciais</span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-stone-800 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            O que nos torna únicos
          </h2>
          <p className="text-stone-500 text-sm md:text-lg max-w-xl mx-auto">
            Mais do que piso, entregamos uma experiência completa de transformação
          </p>
          <div className="w-12 h-0.5 bg-amber-600 mx-auto mt-5" />
        </div>

        {/* Diferenciais - mobile: compact cards, desktop: alternating layout */}
        <div className="flex flex-col gap-6 md:gap-20">
          {diferenciais.map((d, i) => (
            <div key={d.num}>
              {/* Mobile card */}
              <div className="md:hidden bg-white rounded-2xl overflow-hidden border border-stone-100">
                <div className="relative" style={{ height: "180px" }}>
                  <img
                    src={d.img}
                    alt={d.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-3 left-3 bg-amber-700 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                    {d.num}
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                      <i className={`${d.icon} text-lg text-amber-700`} />
                    </div>
                    <h3 className="text-base font-bold text-stone-800" style={{ fontFamily: "'Playfair Display', serif" }}>
                      {d.title}
                    </h3>
                  </div>
                  <p className="text-stone-500 text-sm leading-relaxed mb-4">{d.desc}</p>
                  <ul className="flex flex-col gap-2">
                    {d.checks.map((c) => (
                      <li key={c} className="flex items-center gap-2 text-stone-700 text-xs">
                        <div className="w-4 h-4 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
                          <i className="ri-check-line text-amber-700 text-xs" />
                        </div>
                        {c}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Desktop alternating layout */}
              <div className={`hidden md:grid grid-cols-2 gap-12 items-center ${i % 2 === 1 ? "" : ""}`}>
                <div className={`relative ${i % 2 === 1 ? "order-2" : ""}`}>
                  <div className="rounded-2xl overflow-hidden" style={{ height: "360px" }}>
                    <img
                      src={d.img}
                      alt={d.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute -top-6 -left-4 text-8xl font-bold text-amber-100 select-none pointer-events-none" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {d.num}
                  </div>
                </div>
                <div className={i % 2 === 1 ? "order-1" : ""}>
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-xl mb-5">
                    <i className={`${d.icon} text-2xl text-amber-700`} />
                  </div>
                  <h3 className="text-2xl md:text-3xl font-bold text-stone-800 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {d.title}
                  </h3>
                  <p className="text-stone-500 text-base leading-relaxed mb-6">{d.desc}</p>
                  <ul className="flex flex-col gap-3">
                    {d.checks.map((c) => (
                      <li key={c} className="flex items-center gap-3 text-stone-700 text-sm">
                        <div className="w-5 h-5 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
                          <i className="ri-check-line text-amber-700 text-xs" />
                        </div>
                        {c}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagamento Section */}
        <div className="mt-14 md:mt-24">
          <div className="text-center mb-8 md:mb-12">
            <span className="inline-block text-amber-700 text-xs font-bold tracking-widest uppercase mb-3">Facilidade de Pagamento</span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-stone-800 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
              Realize seu projeto agora
            </h2>
            <p className="text-stone-500 text-sm md:text-base">Diversas formas de pagamento para você não adiar mais essa transformação</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
            {[
              { icon: "ri-bank-card-line", title: "Cartão de Crédito", sub: "Em até 12x sem juros", color: "bg-amber-50" },
              { icon: "ri-qr-code-line", title: "PIX", sub: "Desconto especial à vista", color: "bg-stone-50" },
              { icon: "ri-bank-card-2-line", title: "Débito", sub: "Pagamento imediato", color: "bg-amber-50" },
              { icon: "ri-money-dollar-circle-line", title: "Dinheiro", sub: "Melhor condição", color: "bg-stone-50" },
            ].map((p) => (
              <div key={p.title} className={`${p.color} rounded-xl md:rounded-2xl p-4 md:p-6 text-center border border-stone-100 hover:-translate-y-1 transition-all duration-300`}>
                <div className="w-11 h-11 md:w-14 md:h-14 flex items-center justify-center bg-white rounded-lg md:rounded-xl mx-auto mb-3 md:mb-4">
                  <i className={`${p.icon} text-xl md:text-2xl text-amber-700`} />
                </div>
                <p className="font-bold text-stone-800 text-xs md:text-sm mb-1">{p.title}</p>
                <p className="text-stone-400 text-xs">{p.sub}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-10 md:mt-16">
          <a
            href="https://wa.me/11937354692?text=Ol%C3%A1%2C%20quero%20solicitar%20um%20or%C3%A7amento%20gratuito"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-amber-700 hover:bg-amber-600 text-white font-semibold text-sm px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-list-3-line text-base" />
            Solicite seu orçamento gratuito
          </a>
        </div>
      </div>
    </section>
  );
}